//MAIN IMAGE
export const DELETE_MAIN_IMAGE = "DELETE_MAIN_IMAGE"
export const UPDATE_MAIN_IMAGE = "UPDATE_MAIN_IMAGE"
export const UPDATE_HASHTAG = "UPDATE_HASHTAG"
export const UPDATE_STOREDESCRIPTION = "UPDATE_STOREDESCRIPTION"
export const UPDATE_HASHTAGS_TO_LINE = "UPDATE_HASHTAGS_TO_LINE"
export const CHANGE_HASHTAG = "CHANGE_HASHTAG"
export const DELETE_HASHTAG = "DELETE_HASHTAG"